// ID especial para la categoría virtual de productos frecuentes en el POS.
export const FREQUENT_CATEGORY_ID = '__frequent__';
